import { render, staticRenderFns } from "./CreateWordDocument.vue?vue&type=template&id=7219975f&"
import script from "./CreateWordDocument.vue?vue&type=script&lang=js&"
export * from "./CreateWordDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports